import { useValueChanged } from "../../../hooks/useValueChanged";
import { addTimestamp } from "../../../utils/query";

export const usePreviewSrc = (previewUrl: string, resourcePreview: string) => {
  const resourcePreviewChanged = useValueChanged(resourcePreview, true);
  const preview = resourcePreviewChanged ? addTimestamp(previewUrl) : previewUrl;

  return !previewUrl || !resourcePreview ? null : preview;
};
